import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { showToast } from "../../utils/ToastHelper";
import axios from "axios";
import { BASE_URL } from "./Url";

const VerifyVoucher = ({
  number,
  success,
  setSuccess,
  productIds,
  setVoucherData,
  total
}) => {
  const [isLoading, setIsloading] = useState(false);
  const [pointValue, setPointValue] = useState("");
  
  function getIds(obj) {
    // Array to store the result
    const ids = [];

    // Iterate over each key in the object
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        // Push the main id into the ids array
        ids.push(obj[key].id);
      }
    }

    return ids;
  }

  const ids = getIds(productIds);
  const verifyPoint = async () => {
    const url = `${BASE_URL}api/v1/order/web/verify-coupon/`;
    // Always use the latest total value from the parent,
    // and block zero-total invoices before calling the API.
    const mainTotal = total();
    if (mainTotal === 0) {
      showToast("error", "Total amount should be greater than 0.");
      return;
    }

    setIsloading(true);
    setSuccess(false);
    try {
      const res = await axios.post(url, {
        code: pointValue,
        // mobile: number,
        // product_ids: ids,
        // purchased_amount: mainTotal
      });
      
      // API now returns something like:
      // {
      //   status: "success",
      //   code: 200,
      //   data: {
      //     success: "Voucher is valid",
      //     voucher: {
      //       id, code, discount_type, discount_value, max_discount, minimum_purchase
      //     }
      //   }
      // }
      const { status, code, data } = res.data || {};
      const isSuccess = status === "success" || status === true || code === 200;

      if (isSuccess && data?.voucher) {
        showToast("success", "Voucher Verified.");
        setSuccess(true);
        console.log(data, "verify-coupon data");

        const apiVoucher = data.voucher || {};

        // Safely normalize numeric fields
        const discountType = apiVoucher.discount_type;
        const discountValue = Number(apiVoucher.discount_value) || 0;
        const maxDiscount = Number(apiVoucher.max_discount) || 0;
        const minimumPurchase = Number(apiVoucher.minimum_purchase) || 0;

        // NOTE:
        // - discount_type === 1 => percentage (e.g. 10 means 10%).
        // - Existing invoice logic (CreateInvoiceLClub) already calculates the
        //   discount amount from discount_value and max_discount, so here we only
        //   normalize and forward the data in the expected structure.
        const normalizedVoucher = {
          data: {
            voucher_details: {
              id: apiVoucher.id,
              code: apiVoucher.code,
              discount_type: discountType,
              discount_value: discountValue,
              max_discount: maxDiscount,
              minimum_purchase: minimumPurchase,
            },
            // These are used downstream (if present) to exclude new arrival products.
            new_arrival_products: data.new_arrival_products || [],
            new_arrival_sku_text: data.new_arrival_sku_text || "",
          },
        };

        setVoucherData(normalizedVoucher);
      }
    } catch (err) {
      let message = "An error occurred";
      if (err.response && err.response.data) {
        const errorData = err.response.data;

        // Check if the 'errors' object contains known keys in priority order
        if (
          errorData.errors &&
          errorData.errors.non_field_errors &&
          errorData.errors.non_field_errors.length > 0
        ) {
          // Extract the first error message from 'non_field_errors'
          message = errorData.errors.non_field_errors[0];
        } else if (
          errorData.errors &&
          typeof errorData.errors.error === "string" &&
          errorData.errors.error.length > 0
        ) {
          // Handle error object like: { "errors": { "error": "This voucher has reached its maximum usage limit (3 times)" } }
          message = errorData.errors.error;
        } else if (errorData.errors && errorData.errors.message) {
          // Check if there is a 'message' in 'errors'
          message = errorData.errors.message;
        } else if (errorData.message) {
          // Check if there is a general 'message'
          message = errorData.message;
        }
      }
      setSuccess(false);
      showToast("error", message);
    } finally {
      setIsloading(false);
    }
  };

  return (
    <div className="col-12 col-md-6">
      <p>Verify Voucher </p>
      <div className="d-flex position-relative ">
        <InputGroup className="mb-3">
          <Form.Control
            aria-label="Username"
            type="text"
            name="voucher"
            disabled={success && pointValue.length === 0}

            value={pointValue}
            onChange={(e) => setPointValue(e.target.value)}
            aria-describedby="basic-addon1"
            style={{ backgroundColor: "#FAFAFA" }}
          />
        </InputGroup>

        <div className="ms-2 mb-3 d-flex gap-1">
          {success ? (
            <>
              <button disabled className="btn btn-small btn-success">
                Verified
              </button>
              {/* <button
                onClick={() => {
                  setSuccess(false);
                }}
                className="btn btn-small btn-danger"
              >
                Reset
              </button> */}
            </>
          ) : (
            <>
              {isLoading ? (
                <button disabled className="btn btn-small btn-danger">
                  Verifying...
                </button>
              ) : (
                <button
                  onClick={verifyPoint}
                  disabled={pointValue.length === 0}
                  className="btn btn-small btn-danger"
                >
                  Verify
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyVoucher;
